import { Button } from '@eleveo/components-react';
import { CalendarIcon } from '@eleveo/icons-react';
import { TFunction } from 'i18next';
import React from 'react';
import { Link } from 'react-router-dom';

import { PATH_MY_SCHEDULE } from '../../router/routes';

interface MyScheduleTypeSwitcherProps {
  date?: Date;
  t: TFunction;
  type: 'monthly' | 'weekly';
}

export const MyScheduleTypeSwitcher: React.FC<MyScheduleTypeSwitcherProps> = ({ date, type, t }) => {
  const detailViewPathname = `${PATH_MY_SCHEDULE}/${type}`;
  const buttonText = t(`schedule.mySchedule.${type}View`);

  return (
    <Button
      as={Link}
      testId="schedule-type-switcher-button"
      title={buttonText}
      to={{ pathname: detailViewPathname, state: { date } }}
    >
      <CalendarIcon />
      {buttonText}
    </Button>
  );
};
